module.exports = "<h2>404</h2>\n<p>We couldn't find that page! Not even with x-ray vision.</p> "